import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "steps-content" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "检测结果通知级别", -1)
const _hoisted_7 = { class: "btn_status" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "不通知", -1)
const _hoisted_10 = { class: "icon_wrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "记录", -1)
const _hoisted_13 = { class: "icon_wrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "提醒", -1)
const _hoisted_16 = { class: "icon_wrap" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "警告", -1)
const _hoisted_19 = { class: "icon_wrap" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "检测时排除牙齿", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "row" }

import { addMonitorRule, getRuleInfo, } from '@/api/setting_rule'
import { searchMonitorItems } from '@/api/setting_testItem'
import { LocalStorageService } from '@/components/ts/localStorage'
import { USER_INFO } from '@/store/mutation-types'
import message from 'ant-design-vue/lib/message'
import { reactive, toRefs, onMounted } from 'vue'
import teethDialog from "@/views/task/components/teethDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    isShow: Boolean,
    type: String,
    id: Number
},
  emits: ['onCancel'],
  setup(__props, { emit: emits }) {

const props = __props;



const steps = [
    {
        title: '选择类型',
        content: 'First-content',
    },
    {
        title: '详细配置',
        content: 'Second-content',
    },
]
const data = reactive<{
    visible: boolean,
    current: number,
    activeKey: any[],
    monitorItems: any[],
    abnormalList: any,
    selectedProduct: any[],
    patientMessage: any[],
    doctorMessage: any[],
    teethDialog: boolean,
    teethIndex: number
}>({
    visible: false,
    current: 0,
    activeKey: [],
    monitorItems: [],
    abnormalList: {}, //检测项列表
    selectedProduct: [],//选择的检测项
    patientMessage: [],
    doctorMessage: [],
    teethDialog: false,
    teethIndex: 0
})
const { visible, current, activeKey, monitorItems, selectedProduct} = toRefs(data);
const formData = reactive({
    ruleBrand: 0,
    ruleName: '空白规则',
    description: '',
    scanInterval: 7,
    reminderInterval: 5,
    expireReminderInterval: 3,
    defaultStatus: true,
    id: null,
})

onMounted(() => {
    console.log(props.isShow);
    data.visible = props.isShow
    getInfo();
})

const getInfo = () => {
    searchMonitorItems({
        productLine: 0
    }).then((res: any) => {
        console.log(res);
        // monitorItems.value = res
        if (res) {
            res.forEach((element: { id: any; name: any }) => {
                monitorItems.value.push({
                    "itemId": element.id, // 检测项目id,如对应的矫治器不贴合对应id
                    "name": element.name, // 不贴合异常名称
                    "level": 3, // 检测结果通知级别，1=不通知；2=记录；3=提醒；4=警告
                    "repeatHandle": false, // 是否处理重复结果——,默认为“不处理=0”
                    "maxRepeat": 3, // 最大重复次数
                    "teethIndexExclude": "",// 排除牙齿列表，为空则没有需要排除的牙齿
                    "teethIndexExcludeIsglobal": 0,//是否全局排除,默认为“不处理=0” 1=全局
                    "msg2doctor": '', // 发送消息给医生 对应到消息模板中的消息id
                    "msg2patient": '', // 发送消息给患者,对应到消息模板中的消息id
                })
            });
            if (props.type == 'edit') {
                current.value = 1;
                getRuleInfo(props.id).then((info: any) => {
                    console.log(info);
                    for (const key in info) {
                        formData[key] = info[key]
                    }
                    monitorItems.value.forEach(element => {
                        info.abnormalList.forEach((it: any) => {
                            selectedProduct.value.push(it.itemId)
                            if (element.itemId == it.itemId) {
                                for (const key in element) {
                                    if (key != 'name') {
                                        element[key] = it[key]
                                    }
                                }
                                element.id = it.itemId
                                console.log(element, '222');
                            }
                        });
                    });
                    console.log(monitorItems.value);
                })
            }
        }
    })
//     searchMessage({
//         "page": {
//             "currPage": 1,
//             "pageSize": 1000
//         },
//         "type": 1
//     }).then((res: any) => {
//         console.log(res, '医生消息');
//         doctorMessage.value = res
//     })
//     searchMessage({
//         "page": {
//             "currPage": 1,
//             "pageSize": 1000
//         },
//         "type": 2
//     }).then((res: any) => {
//         console.log(res, '患者消息');
//         patientMessage.value = res
//     })
}

const next = () => {
    current.value++;
};
const prev = () => {
    current.value--;
};
const handleOk = () => {
    let option;
    if (formData.ruleBrand == 0) {
        option = submit1()
    } else {
        option = submit2()
    }
    console.log('提交', option);
    if(option){
        addMonitorRule(option).then(() => {
            visible.value = false
            message.success('规则创建成功');
            emits('onCancel')
        })
    }
}

const submit1 = () => {
    if (selectedProduct.value.length < 1) {
        message.error('请选择检测项');
        return
    }
    // console.log(selectedProduct.value);
    // let isMessage = false
    let abnormalList = monitorItems.value.filter((item, index) => selectedProduct.value[index] == item.itemId)
    // abnormalList.forEach(element => {
    //     if (!element.msg2patient) {
    //         isMessage = true
    //     }
    // });
    // if (isMessage) {
    //     message.error('请选择患者消息');
    //     return
    // }
    let option = {
        ...formData,
        abnormalList,
        ruleType: 1,
        ruleOwner: LocalStorageService.get(USER_INFO).id
    }
    option.defaultStatus = formData.defaultStatus ? 1 : 0
    return option
}

const submit2 = () => {
    let option = {
        // ...formData,
        ruleBrand: formData.ruleBrand,
        ruleName: formData.ruleName,
        description: formData.description,
        scanInterval: formData.scanInterval,
        defaultStatus: formData.defaultStatus ? 1 : 0,
        ruleType: 1,
        ruleOwner: LocalStorageService.get(USER_INFO).id
    }
    // option.defaultStatus = formData.defaultStatus ? 1 : 0
    return option;
}


const oncancel = () => {
    console.log('取消');
    visible.value = false
    emits('onCancel')
}

//设置消息提醒等级
const setMessageLevel = (index: number, level: any) => {
    monitorItems.value[index]['level'] = level
}

const addTeeth = (index: number) => {
    data.teethDialog = true,
        data.teethIndex = index
    data.abnormalList = monitorItems.value[index];
}

const submitTeeth = (abnormal2excludesTeethList: any) => {
    data.teethDialog = false
    monitorItems.value[data.teethIndex].teethIndexExclude = abnormal2excludesTeethList.teethIndexList;
    monitorItems.value[data.teethIndex].teethIndexExcludeIsglobal = abnormal2excludesTeethList.isglobal;
}

const onTeethCancel = () => {
    data.teethDialog = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      title: __props.type == 'add' ? '创建规则' : '规则详情',
      onCancel: oncancel,
      width: "60%"
    }, {
      footer: _withCtx(() => [
        (_unref(current) !== 0)
          ? (_openBlock(), _createBlock(_component_a_checkbox, {
              key: 0,
              checked: formData.defaultStatus,
              "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((formData.defaultStatus) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("设为默认规则")
              ]),
              _: 1
            }, 8, ["checked"]))
          : _createCommentVNode("", true),
        (_unref(current) == 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              onClick: oncancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(current) < steps.length - 1)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "primary",
              onClick: next
            }, {
              default: _withCtx(() => [
                _createTextVNode("下一步")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(current) > 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              style: {"margin-left":"8px"},
              onClick: prev
            }, {
              default: _withCtx(() => [
                _createTextVNode("上一步")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(current) == steps.length - 1 && __props.type == 'add')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              type: "primary",
              onClick: handleOk
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 提交 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_steps, { current: _unref(current) }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (item) => {
              return _createVNode(_component_a_step, {
                key: item.title,
                title: item.title
              }, null, 8, ["title"])
            }), 64))
          ]),
          _: 1
        }, 8, ["current"]),
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_a_card, { bordered: false }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: formData.ruleBrand,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.ruleBrand) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("隐形")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("固定")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("拍照")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _unref(current) == 0]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_a_card, {
              title: "规则名称",
              bordered: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formData.ruleName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.ruleName) = $event)),
                  placeholder: "请输入规则名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, {
              title: "规则描述",
              bordered: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: formData.description,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.description) = $event)),
                  placeholder: "请输入规则描述",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, {
              title: "扫描频率",
              bordered: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode("每隔 "),
                  _createVNode(_component_a_input_number, {
                    min: 1,
                    style: {"width":"80px"},
                    precision: 0,
                    value: formData.scanInterval,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.scanInterval) = $event))
                  }, null, 8, ["value"]),
                  _createTextVNode(" 天要求患者扫描一次 ")
                ]),
                (formData.ruleBrand == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createTextVNode("上次监测结果为佩戴当前步, "),
                      _createVNode(_component_a_input_number, {
                        min: 1,
                        style: {"width":"80px"},
                        precision: 0,
                        value: formData.reminderInterval,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formData.reminderInterval) = $event))
                      }, null, 8, ["value"]),
                      _createTextVNode(" 天要求患者扫描一次 ")
                    ]))
                  : _createCommentVNode("", true),
                (formData.ruleBrand == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createTextVNode("患者过期未扫描 "),
                      _createVNode(_component_a_input_number, {
                        min: 1,
                        style: {"width":"80px"},
                        precision: 0,
                        value: formData.expireReminderInterval,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formData.expireReminderInterval) = $event))
                      }, null, 8, ["value"]),
                      _createTextVNode(" 天要求患者扫描一次 ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (formData.ruleBrand == 0)
              ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                  key: 0,
                  value: _unref(selectedProduct),
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_isRef(selectedProduct) ? (selectedProduct).value = $event : null)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse, {
                      activeKey: _unref(activeKey),
                      "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : null))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monitorItems), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                            key: item.id,
                            showArrow: false
                          }, {
                            header: _withCtx(() => [
                              _createVNode(_component_a_checkbox, {
                                value: item.itemId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["btn_list leve1", item.level === 1 ? 'active' : '']),
                                    onClick: ($event: any) => (setMessageLevel(index, 1))
                                  }, [
                                    _hoisted_9,
                                    _createElementVNode("span", _hoisted_10, [
                                      _createVNode(_component_check_outlined)
                                    ])
                                  ], 10, _hoisted_8),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["btn_list leve2", item.level === 2 ? 'active' : '']),
                                    onClick: ($event: any) => (setMessageLevel(index, 2))
                                  }, [
                                    _hoisted_12,
                                    _createElementVNode("span", _hoisted_13, [
                                      _createVNode(_component_check_outlined)
                                    ])
                                  ], 10, _hoisted_11),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["btn_list leve3", item.level === 3 ? 'active' : '']),
                                    onClick: ($event: any) => (setMessageLevel(index, 3))
                                  }, [
                                    _hoisted_15,
                                    _createElementVNode("span", _hoisted_16, [
                                      _createVNode(_component_check_outlined)
                                    ])
                                  ], 10, _hoisted_14),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["btn_list leve4", item.level === 4 ? 'active' : '']),
                                    onClick: ($event: any) => (setMessageLevel(index, 4))
                                  }, [
                                    _hoisted_18,
                                    _createElementVNode("span", _hoisted_19, [
                                      _createVNode(_component_check_outlined)
                                    ])
                                  ], 10, _hoisted_17)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _hoisted_21,
                                    _createVNode(_component_a_input, {
                                      value: item.teethIndexExclude,
                                      "onUpdate:value": ($event: any) => ((item.teethIndexExclude) = $event),
                                      style: {"width":"200px"},
                                      disabled: ""
                                    }, null, 8, ["value", "onUpdate:value"]),
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      onClick: ($event: any) => (addTeeth(index))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("添加")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (item.name === '矫治器不贴合')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: item.repeatHandle,
                                        "onUpdate:checked": ($event: any) => ((item.repeatHandle) = $event)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("重复出现的处理")
                                        ]),
                                        _: 2
                                      }, 1032, ["checked", "onUpdate:checked"])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createTextVNode("此种情况在同一步连续出现达到 "),
                                      _createVNode(_component_a_input_number, {
                                        min: 1,
                                        style: {"width":"80px"},
                                        precision: 0,
                                        value: item.maxRepeat,
                                        "onUpdate:value": ($event: any) => ((item.maxRepeat) = $event)
                                      }, null, 8, ["value", "onUpdate:value"]),
                                      _createTextVNode(" 次，通知患者更换下一步 ")
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["activeKey"])
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _unref(current) == 1]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    (data.teethDialog)
      ? (_openBlock(), _createBlock(teethDialog, {
          key: 0,
          abnormalList: data.abnormalList,
          visible: data.teethDialog,
          onOk: submitTeeth,
          onCancel: onTeethCancel
        }, null, 8, ["abnormalList", "visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})